import { Loader } from '@mantine/core';

import { Page } from '@/components/page.tsx';

interface Props {
    text?: string;
}

export const LoadingPage = ({ text }: Props) => {
    return (
        <Page className="flex flex-col items-center justify-center gap-8" fullScreen>
            {text && <h2 className="text-3xl">{text}</h2>}
            <Loader />
        </Page>
    );
};
